var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full flex-grow overflow-y-auto"},[(_vm.clientCosts && _vm.clientCosts.length)?_c('InformationContainer',{attrs:{"client-costs":_vm.clientCosts}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }